// A confirm window in the site's own style, instead of the browser's plain confirm box.
//   if (!(await confirmDialog({ title: 'Delete this message?', message: '…', confirmLabel: 'Delete', danger: true }))) return;
// Resolves true when confirmed; Escape, Cancel or a click outside resolve false.
import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';

function ConfirmWindow({ title, message, confirmLabel, cancelLabel, danger, onDone }) {
  const cancelRef = useRef(null);
  const confirmRef = useRef(null);
  useEffect(() => {
    // For something that can't be undone, the safe choice gets the focus.
    (danger ? cancelRef : confirmRef).current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onDone(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [danger, onDone]);
  return (
    <div className="modal-backdrop confirm-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onDone(false)}>
      <div className={`modal confirm-window${danger ? ' danger' : ''}`} role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-message">
        <div className="confirm-icon" aria-hidden="true">{danger ? '!' : '?'}</div>
        <h2 id="confirm-title">{title}</h2>
        {message && <p id="confirm-message" className="confirm-message">{message}</p>}
        <div className="confirm-actions">
          <button type="button" ref={cancelRef} className="secondary" onClick={() => onDone(false)}>{cancelLabel}</button>
          <button type="button" ref={confirmRef} className={danger ? 'danger' : ''} onClick={() => onDone(true)}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export function confirmDialog({ title, message = '', confirmLabel = 'OK', cancelLabel = 'Cancel', danger = false }) {
  return new Promise((resolve) => {
    const host = document.createElement('div');
    document.body.appendChild(host);
    const root = createRoot(host);
    const before = document.activeElement;
    const done = (answer) => {
      root.unmount();
      host.remove();
      if (before && before.focus) before.focus();
      resolve(answer);
    };
    root.render(<ConfirmWindow title={title} message={message} confirmLabel={confirmLabel} cancelLabel={cancelLabel} danger={danger} onDone={done} />);
  });
}
